define('apps/course-intro/views/regions/modules/content',[
    'apps/course-intro/templates/regions/modules/content',
    'apps/course-intro/views/regions/modules/module-grid',
    'components/asset-player/main',
    'components/transition/transition'
], function (template, ModuleGridView, assetPlayer, Transition) {
    "use strict";

    return Mn.LayoutView.extend({

        "template": template,

        "regions": {
            "grid": ".grid-region"
        },

        "onRender": function () {
            var playerChannel = assetPlayer.channel,
                modules = this.model.get('modules');

            modules.levelGuid = this.model.get('_id');
            modules.levelNum = this.model.get('levelNum');

            this.showChildView('grid', new ModuleGridView({
                "collection": modules
            }));

            playerChannel.command(playerChannel.Event.RENDER, {
                "target": this.$el
            });
        },

        "onShow": function () {
            Transition.create({
                "direction": Transition.Direction.DOWN,
                "context": this,
                "el": $('h1', this.el),
                "type": Transition.Type.FADE_IN,
                "duration": 1.2
            }).start();
        }
    });
});

